import React, {useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import './MerchantAccount.scss';
import MerchantAccountDetailsCard from '../../../shared/cards/MerchantAccountDetailsCard/MerchantAccountDetailsCard';
import MerchantAccountDetailsSubCard from '../../../shared/cards/MerchantAccountDetailsSubCard/MerchantAccountDetailsSubCard';
import { InputLabel, FormControl, MenuItem, Select, Grid, TextField, Typography } from '@mui/material';
import { Checkmate, Otter, Stream, Olo, ENTER_USERNAME, ENTER_EMAIL } from '../../../constants/Admin/MerchantAccountConstants';
import { BACK_BUTTON, CREATE_ACCOUNT, BRAND_NAME, AGGREGATOR, CREATE_A_MERCHANT_ACCOUNT, MERCHANT_ACCOUNT, CHOOSE_AGGREGATOR, BRAND_NAME_POPULATE_BRAND, BRAND_NAME_POPULATE_ORGANIZATION, ORGANIZATION_NAME, CHECKMATE, OLO, OTTER, STREAM, CONTINUE } from '../../../constants/Admin/MerchantAccountConstants';
import { createAccountOTTERIACMResponseSaga } from '../../../redux/saga/accountServiceSelector';
import { loadingInProgress } from '../../../redux/actions/loginServiceAction';
import { createAccountOTTERIACMRequest } from '../../../redux/actions/accountServiceAction';
import CustomStatusPage from '../../../shared/pages/custom.status';
import { getmerchantsInfoRequest } from '../../../redux/actions/adminFlow/merchantInfoAction';
import{ merchantInfoDataSaga, merchantInfoDataErrorSaga } from '../../../redux/saga/adminFlow/merchantInfoSelector';
import { activelocations, activelocationslist, activebusinessname, activebrandid, activeusername,activeemail } from '../../../redux/actions/adminFlow/merchantInfoAction';
import { isValidEmail } from '../../../shared/utils/format.helpers';
import { createAccountRequest } from '../../../redux/actions/adminFlow/createAccountAction';
import { selectCreateAccountResponseData } from '../../../redux/saga/adminFlow/createAccountSelector';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

const  MerchantAccount = () => {

	const [ aggregator, setAggregator ] = useState('');
	const [ aggregatorProp, setAggregatorProp ] = useState('');
	const [ aggregatorSelected, setAggregatorSelected ] = useState(false);
	const [ checkmateBusinessEmail, setCheckmateBusinessEmail] = useState('');
	const [ checkmateUsername, setCheckmateUsername ] = useState('');
	const [ checkmateFormValid, setCheckmateFormValid ] = useState(false);
	const [ emailError, setEmailError ] = useState(false);
	const [ userNameError, setUserNameError ] = useState(false);
	const [ checkmatebrandName, setCheckmateBrandName] = useState('');
	const [ otterBusinessEmail, setOtterBusinessEmail] = useState('');
	const [ otterUsername, setOtterUsername ] = useState('');
	const [ otterFormValid, setOtterFormValid ] = useState(false);
	const [ otterOrganizationName, setotterOrganizationName] = useState('');
	const [ oloBusinessEmail, setOloBusinessEmail] = useState('');
	const [ oloUsername, setOloUsername ] = useState('');
	const [ oloFormValid, setOloFormValid ] = useState(false);
	const [ olobrandName, setOloBrandName] = useState('');
	const [ streamBusinessEmail, setStreamBusinessEmail] = useState('');
	const [ streamUsername, setStreamUsername ] = useState('');
	const [ streamFormValid, setStreamFormValid ] = useState(false);
	const [ streambrandName, setStreamBrandName] = useState('');	
	const [step, setStep] = useState(1);
	const createAccountResponse = useSelector(createAccountOTTERIACMResponseSaga);
	const createAccountResponse1 = useSelector(selectCreateAccountResponseData);
	const [errormsg, seterrormsg]= useState('');
	const [statusComponent, setStatusComponent] = useState(null);
	const dispatch = useDispatch();
	const merchantsdata =  useSelector(merchantInfoDataSaga);
	const merchantsdataerror = useSelector(merchantInfoDataErrorSaga);
	const [filteredBrandNames, setFilteredBrandNames] = useState([]);
	const [selectedBrand, setSelectedBrand] = useState({ brandName: '', brandId: '', locations: '', addressList: '' });

	useEffect(() => {
		//console.log('responseData ',createAccountResponse);
		if (createAccountResponse) {
		  dispatch(loadingInProgress(false));
		  setStatusComponent(<CustomStatusPage statusIndicator='User_Created' />);
		  if (createAccountResponse?.msg) {
			if (createAccountResponse?.details?.data?.message === 'Username/Email already taken. Please try another.' ) {
				seterrormsg(createAccountResponse?.details?.data?.message);
				setStatusComponent(null);
			} else if (createAccountResponse.details?.data?.message) {
			  setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			} else if (createAccountResponse.details?.code === 'ECONNABORTED') {
			  setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			} else {
			  setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			}
		  } else {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Created' />);
		  }
		}
		else{
		  setStatusComponent(null);
		}
	}, [createAccountResponse]);

	useEffect(() => {
		//console.log('responseData1 ',createAccountResponse1);
		if (createAccountResponse1) {
		  dispatch(loadingInProgress(false));
		  setStatusComponent(<CustomStatusPage statusIndicator='User_Created' />);
		  if (createAccountResponse1?.msg || createAccountResponse1?.data?.message) {
			if (createAccountResponse1?.data?.response?.data?.message === 'Username/Email already taken. Please try another.' ) {
				seterrormsg(createAccountResponse1?.data?.response?.data?.message);
				setStatusComponent(null);
			} else if (createAccountResponse1.details?.data?.message) {
				setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			} else if (createAccountResponse1.details?.code === 'ECONNABORTED' || createAccountResponse1.data?.code === 'ERR_BAD_RESPONSE') {
			  setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			} 
			else {
			  setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
			}
		  } else {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Created' />);
		  }
		}
		else{
		  setStatusComponent(null);
		}
	}, [createAccountResponse1]);

	const handleAggregatorChange = (event) => {
		setAggregator(event.target.value);
		setAggregatorSelected(true);
	}

	const continueToStep2 = () => {
		setStep(2);
		setAggregatorProp(aggregator);
	}
	const backToStep1 = () => {
		setStep(1);
		//setAggregator('');
	}
	//this function handels all 4 email changes
	const handleBusinessEmail = (event) => {
		setCheckmateBusinessEmail(event.target.value);
		setOloBusinessEmail(event.target.value);
		setOtterBusinessEmail(event.target.value);
		setStreamBusinessEmail(event.target.value);
		if(isValidEmail(event.target.value)) {
			setEmailError(false);
		} else {
			setEmailError(true);
			setCheckmateFormValid(false);
			setOloFormValid(false);
			setOtterFormValid(false);
			setStreamFormValid(false);
		}
	}
	//this function handels all 4 username changes
	const handleUsername = (event) => {
		setCheckmateUsername(event.target.value);
		setOloUsername(event.target.value);
		setOtterUsername(event.target.value);
		setStreamUsername(event.target.value);
		if(event.target.value) {
			setUserNameError(false);
		} else {
			setUserNameError(true);
			setCheckmateFormValid(false);
			setOloFormValid(false);
			setOtterFormValid(false);
			setStreamFormValid(false);
		}
	}
	//commenting this function as brand field is disabled
	//const handleCheckmateBrandChange = () => {
	//}
	const createAccountCheckMate = (e) => {
		seterrormsg('');
		e.preventDefault();
		dispatch(loadingInProgress(true))
		dispatch(
		  createAccountOTTERIACMRequest(
				checkmateUsername	,
				checkmateBusinessEmail,
				'','',
				aggregator
		  )
		);
	}

	useEffect(() => {
		if(step === 2 && aggregator === 'itsacheckmate'){
			setCheckmateFormValid(!emailError && !userNameError &&  checkmateUsername && checkmateBusinessEmail);
		}
		if(step === 2 && aggregator === 'olo'){
			setOloFormValid(!emailError && !userNameError && oloUsername && oloBusinessEmail && selectedBrand.brandName);
		}
		if(step === 2 && aggregator === 'otter'){
			setOtterFormValid(!emailError && !userNameError && otterUsername && otterBusinessEmail);
		}
		if(step === 2 && aggregator === 'stream'){
			setStreamFormValid(!emailError && !userNameError && streamUsername && streamBusinessEmail && selectedBrand.brandName);
		}
	}, [checkmateUsername, checkmateBusinessEmail, emailError, userNameError, selectedBrand, oloUsername, oloBusinessEmail, otterUsername, otterBusinessEmail, streamUsername, streamBusinessEmail, step, aggregator]);

	//dispatch action to get merchants info request
	useEffect (()=>{
		if((step === 2) && ((aggregator === 'olo') || (aggregator === 'stream') )) {
			const pageNum = 0 ;
			const pageSize = 100000 ;
			const sortBy = 'isAccountCreated' ;
			const sortOrder = 'Ascending' ;
			const retriveMerchantInfoqueryParams= { pageNum, pageSize, sortBy, sortOrder, aggregator };
			dispatch(getmerchantsInfoRequest(retriveMerchantInfoqueryParams));
		}
		if(step === 1){
			setEmailError(false);
			setUserNameError(false);
			setSelectedBrand('');
			setCheckmateBusinessEmail('');
			setCheckmateUsername('');
			setCheckmateFormValid(false);
			setOtterBusinessEmail('');
			setOtterUsername('');
			setOtterFormValid(false);
			setStreamBrandName('');
			setStreamBusinessEmail('');
			setStreamUsername('');
			setStreamFormValid(false);
			setOloBusinessEmail('');
			setOloUsername('');
			setOloBrandName('');
			setOloFormValid(false);
			setStatusComponent(null);
			dispatch(activelocations(parseInt('')));
			dispatch(activelocationslist(''));
			dispatch(activebusinessname(''));
			dispatch(activebrandid(''));
			seterrormsg('');
			setAggregatorProp('');
		}
	},[step, aggregator]);

	useEffect(() => {
		//console.log('Merchants data:', merchantsdata);
		//console.log('Merchants data error:', merchantsdataerror);
		if (merchantsdata && Array.isArray(merchantsdata.content)) {
			const filteredBrandNames = merchantsdata.content.map(item => ({
				brandName: item.brandName,
				locations: item.locations,
				brandId: item.brandId,
				addressList: item.addressList,
				aggregator: item.aggregator,
				businessName: item.businessName,
				isAccountCreated: item.isAccountCreated
			}));
			setFilteredBrandNames(filteredBrandNames);
			//console.log('filtered Merchants data:', filteredBrandNames);
		}
	}, [merchantsdata, merchantsdataerror]);

	//this function is same for olo and stream brand change
	const handleOloStreamBrandChange = (brandId) => {
		if (!brandId) {
			setStreamBrandName('');
			setOloBrandName('');
			setSelectedBrand({ brandName: '', brandId: '', locations: '', addressList: '' });
			dispatch(activelocations(null));
			dispatch(activelocationslist([]));
			dispatch(activebusinessname(''));
			dispatch(activebrandid(''));
			return;
		}
		setStreamBrandName(brandId);
		setOloBrandName(brandId);
		const selectedBrand = filteredBrandNames.find(item => item.brandId === brandId);
		setSelectedBrand(selectedBrand);
		dispatch(activelocations(parseInt(selectedBrand.locations)));
		//dispatch(activelocationslist(totaladdresslists));
		dispatch(activebusinessname(selectedBrand.businessName));
		dispatch(activebrandid(selectedBrand.brandId));
	};
	
	const createAccountOlo = () => {
		seterrormsg('');
		let oloObj = {
			aggregator,
			emailId: oloBusinessEmail,
			userName: oloUsername,
			brand: selectedBrand.brandName,
			brandId: selectedBrand.brandId
		}
		//console.log('dispatch action', oloObj);
		//console.log('selected location', selectedBrand.locations);
		//console.log('selected addressList', selectedBrand.addressList);
		dispatch(activeusername(oloUsername));
		dispatch(activeemail(oloBusinessEmail));
		try {
			dispatch(createAccountRequest(oloObj));
			dispatch(loadingInProgress(true));
		} catch (error) {
			//console.error('Error submitting:', error);
		}

	}
	//commenting this function as org field is disabled
	//const handleOtterOrganizationNameChange = () => {
	//}
	// create account button on otter page
	const createAccountOtter = (e) => {
		seterrormsg('');
		e.preventDefault();
		dispatch(loadingInProgress(true))
		dispatch(
		  createAccountOTTERIACMRequest(
				otterUsername,
				otterBusinessEmail,
				'','',
				aggregator
		  )
		);
	}
	// create account button on Stream page
	const createAccountStream = () => {
		seterrormsg('');
		let streamObj = {
			aggregator,
			emailId: streamBusinessEmail,
			userName: streamUsername,
			brand: selectedBrand.brandName,
			brandId: selectedBrand.brandId
		}
		//console.log('dispatch action', streamObj);
		dispatch(activeusername(streamBusinessEmail));
		dispatch(activeemail(streamUsername));
		try {
			dispatch(createAccountRequest(streamObj));
			dispatch(loadingInProgress(true));
		} catch (error) {
			//console.error('Error submitting:', error);
		}
	}

	return (
		<>
		{statusComponent? statusComponent:
			<div className='merchantAccount'>
				<Paper className='page-header'>
					<h4 className='title-class' data-testid='admin-homepage'>{MERCHANT_ACCOUNT}</h4>
				</Paper>
				{(step === 1) && 
					<Paper className='merchantAccount-content'>
						<div className='merchantAccount-section1'>
							<p className='merchantAccount-title1'>{CREATE_A_MERCHANT_ACCOUNT}</p>
							<p className='merchantAccount-subtitle1'>{CHOOSE_AGGREGATOR}</p>
						</div>
						<div className='merchantAccount-section2'>
							<FormControl sx={{height: '56px', width: '356px'}}>
								<InputLabel id='aggregator-select'>{AGGREGATOR}</InputLabel>
								<Select
									labelId='aggregator-select'
									id='demo-simple-select'
									className='select-box'
									value={aggregator}
									label='{AGGREGATOR}'
									onChange={handleAggregatorChange}
								>
									<MenuItem selected value='itsacheckmate'>{CHECKMATE}</MenuItem>
									<MenuItem selected value='olo'>{OLO}</MenuItem>
									<MenuItem selected value='otter'>{OTTER}</MenuItem>
									<MenuItem selected value='stream'>{STREAM}</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className='merchantAccount-section3'>
							<button
								className='continue-button--primaryButton'
								aria-label='Continue'
								disabled={!aggregatorSelected}
								variant='outlined'
								onClick={continueToStep2}
							>
								{CONTINUE}
							</button>
						</div>
					</Paper>
				}
				{((step === 2) && (aggregator === 'itsacheckmate')) &&
					<Paper className='merchantAccount-content'>
						<div className='merchantAccount-section1'>
							<p className='merchantAccount-title1'>{CREATE_A_MERCHANT_ACCOUNT}</p>
							<p className='merchantAccount-subtitle1'>{BRAND_NAME_POPULATE_BRAND}</p>
						</div>
						<div className='merchantAccount-template1'>
							<div className='form-section'>

								<FormControl>
								<Grid container spacing={2}>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background text-capitalize'>
												<InputLabel>{AGGREGATOR}</InputLabel>
												<Select
													value={aggregator}
													id='checkmate-aggregator'
													data-testid='checkmate-aggregator'
													onChange={handleAggregatorChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem value={aggregator}>{aggregator}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background'>
												<InputLabel>{BRAND_NAME}</InputLabel>
												<Select
													value={checkmatebrandName}
													id='checkmatebrandName' 
													data-testid='checkmatebrandName'
													//onChange={handleCheckmateBrandChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem  value=''>{BRAND_NAME}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid> 
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<TextField 
												type='email' 
												label='Business Email*'
												size='normal' 
												value={checkmateBusinessEmail}
												id='checkmateBusinessEmail'
												data-testid='checkmateBusinessEmail'
												onChange={handleBusinessEmail}
												error={emailError}
												helperText={emailError ? ENTER_EMAIL : ''}
												/>
										</Grid>
										<Grid item xs={6}>
											<TextField 
												label='Username*'
												id='checkmateUsername'
												data-testid='checkmateUsername'
												name='username'
												variant='outlined'
												fullWidth
												value={checkmateUsername}
												onChange={handleUsername}
												error={userNameError}
												helperText={userNameError ? ENTER_USERNAME : ''} 
											/>
										</Grid>
									</Grid>
									
								</FormControl>
								<MerchantAccountDetailsSubCard SUBHEADER1={Checkmate.SUBHEADER1} HEADER_TEXT1={Checkmate.HEADER_TEXT1} SUBHEADER2={Checkmate.SUBHEADER2} HEADER_TEXT2={Checkmate.HEADER_TEXT2}/>

							</div>
							{errormsg && <div className='error-msg'>{errormsg}</div> }
						</div>
						<div className='merchantAccount-section3'>
							<button 
								onClick={backToStep1}
								className='backButton'
							> 
								{BACK_BUTTON}
							</button>
							<button
								className='continue-button--primaryButton'
								aria-label='Create Account'
								disabled={!checkmateFormValid}
								variant='outlined'
								onClick={createAccountCheckMate}
								id='createAccountCheckMate'
								data-testid='createAccountCheckMate'
							>
								{CREATE_ACCOUNT}
							</button>
						</div>

					</Paper>
				}
				{((step === 2) && (aggregator === 'olo')) &&
					<Paper className='merchantAccount-content'>
						<div className='merchantAccount-section1'>
							<p className='merchantAccount-title1'>{CREATE_A_MERCHANT_ACCOUNT}</p>
						</div>
						<div className='merchantAccount-template1'>
							<div className='form-section'>

								<FormControl>
								<Grid container spacing={2}>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background text-capitalize'>
												<InputLabel>{AGGREGATOR}</InputLabel>
												<Select
													value={aggregator}
													id='olo-aggregator' 
													data-testid='olo-aggregator'
													onChange={handleAggregatorChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem value={aggregator}>{aggregator}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={6}>
											<Autocomplete
												id='olobrandName'
												data-testid='olobrandName'
												options={filteredBrandNames.filter(item => item.isAccountCreated === false && item.aggregator.toLowerCase() === 'olo')}
												getOptionLabel={(option) => option.brandName}
												onChange={(event, newValue) => {
													handleOloStreamBrandChange(newValue?.brandId || '');
												}}
												renderInput={(params) => (
													<TextField 
														{...params} 
														label={BRAND_NAME} 
														variant='outlined' 
														placeholder='Select One'
														InputProps={{
															...params.InputProps,
															startAdornment: (
																<InputAdornment position='start'>
																	<SearchIcon />
																</InputAdornment>
															),
														}}
													/>
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.brandId}>
														{option.brandName}
													</li>
												)}
											/>
										</Grid>
									</Grid> 
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<TextField 
												type='email' 
												label='Business Email*'
												size='normal' 
												value={oloBusinessEmail}
												id='oloBusinessEmail'
												data-testid='oloBusinessEmail'
												onChange={handleBusinessEmail}
												error={emailError} 
												helperText={emailError ? ENTER_EMAIL : ''}
												/>
										</Grid>
										<Grid item xs={6}>
											<TextField 
												label='Username*'
												id='oloUsername'
												data-testid='oloUsername'
												name='username'
												variant='outlined'
												fullWidth 
												value={oloUsername}
												onChange={handleUsername}
												error={userNameError}
												helperText={userNameError ? ENTER_USERNAME : ''} 
											/>
										</Grid>
									</Grid>
									
								</FormControl>
								<MerchantAccountDetailsSubCard SUBHEADER1={Olo.SUBHEADER1} HEADER_TEXT1={Olo.HEADER_TEXT1} SUBHEADER2={Olo.SUBHEADER2} HEADER_TEXT2={Olo.HEADER_TEXT2}/>

							</div>
							{errormsg && <div className='error-msg'>{errormsg}</div> }
						</div>
						<div className='merchantAccount-section3'>
							<button 
								onClick={backToStep1}
								className='backButton'
							> 
								{BACK_BUTTON}
							</button>
							<button
								className='continue-button--primaryButton'
								aria-label='Create Account'
								disabled={!oloFormValid}
								variant='outlined'
								onClick={createAccountOlo}
								id='createAccountOlo'
								data-testid='createAccountOlo'
							>
								{CREATE_ACCOUNT}
							</button>
						</div>

					</Paper>
				}
				{((step === 2) && (aggregator === 'otter')) &&
					<Paper className='merchantAccount-content'>
						<div className='merchantAccount-section1'>
							<p className='merchantAccount-title1'>{CREATE_A_MERCHANT_ACCOUNT}</p>
							<p className='merchantAccount-subtitle1'>{BRAND_NAME_POPULATE_ORGANIZATION}</p>
						</div>
						<div className='merchantAccount-template1'>
							<div className='form-section'>

								<FormControl>
								<Grid container spacing={2}>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background text-capitalize'>
												<InputLabel>{AGGREGATOR}</InputLabel>
												<Select
													value={aggregator}
													id='otter-aggregator' 
													data-testid='otter-aggregator'
													onChange={handleAggregatorChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem value={aggregator}>{aggregator}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background'>
												<InputLabel>{ORGANIZATION_NAME}</InputLabel>
												<Select
													value={otterOrganizationName}
													id='otterOrganizationName' 
													data-testid='otterOrganizationName'
													//onChange={handleOtterOrganizationNameChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem  value=''>{ORGANIZATION_NAME}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid> 
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<TextField 
												type='email' 
												label='Business Email*'
												size='normal' 
												value={otterBusinessEmail}
												id='otterBusinessEmail'
												data-testid='otterBusinessEmail'
												onChange={handleBusinessEmail}
												error={emailError} 
												helperText={emailError ? ENTER_EMAIL : ''}
												/>
										</Grid>
										<Grid item xs={6}>
											<TextField 
												label='Username*'
												id='otterUsername'
												data-testid='otterUsername'
												name='username'
												variant='outlined'
												fullWidth
												value={otterUsername}
												onChange={handleUsername}
												error={userNameError}
												helperText={userNameError ? ENTER_USERNAME : ''} 
											/>
										</Grid>
									</Grid>
									
								</FormControl>
								<MerchantAccountDetailsSubCard SUBHEADER2={Otter.SUBHEADER2} HEADER_TEXT2={Otter.HEADER_TEXT2}/>

							</div>
							{errormsg && <div className='error-msg'>{errormsg}</div> }
						</div>
						<div className='merchantAccount-section3'>
							<button 
								onClick={backToStep1}
								className='backButton'
							> 
								{BACK_BUTTON}
							</button>
							<button
								className='continue-button--primaryButton'
								aria-label='Create Account'
								disabled={!otterFormValid}
								variant='outlined'
								onClick={createAccountOtter}
								id='createAccountOtter'
								data-testid='createAccountOtter'
							>
								{CREATE_ACCOUNT}
							</button>
						</div>

					</Paper>
				}
				{((step === 2) && (aggregator === 'stream')) &&
					<Paper className='merchantAccount-content'>
						<div className='merchantAccount-section1'>
							<p className='merchantAccount-title1'>{CREATE_A_MERCHANT_ACCOUNT}</p>
						</div>
						<div className='merchantAccount-template1'>
							<div className='form-section'>

								<FormControl>
								<Grid container spacing={2}>
										<Grid item xs={6}>
											<FormControl fullWidth className='disabled-background text-capitalize'>
												<InputLabel>{AGGREGATOR}</InputLabel>
												<Select
													value={aggregator}
													id='stream-aggregator' 
													data-testid='stream-aggregator'
													onChange={handleAggregatorChange}
													variant='outlined'
													//error={brandselectionError}
													disabled={true}
												>
												<MenuItem value={aggregator}>{aggregator}</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={6}>
											<Autocomplete
												id='streambrandName'
												data-testid='streambrandName'
												options={filteredBrandNames.filter(item => item.isAccountCreated === false && item.aggregator.toLowerCase() === 'stream')}
												getOptionLabel={(option) => option.brandName}
												onChange={(event, newValue) => {
													handleOloStreamBrandChange(newValue?.brandId || '');
												}}
												renderInput={(params) => (
													<TextField 
														{...params} 
														label={BRAND_NAME} 
														variant='outlined'
														placeholder='Select One'
														InputProps={{
															...params.InputProps,
															startAdornment: (
																<InputAdornment position='start'>
																	<SearchIcon />
																</InputAdornment>
															),
														}}
													/>
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.brandId}>
														{option.brandName}
													</li>
												)}
											/>
										</Grid>
									</Grid> 
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<TextField 
												type='email' 
												label='Business Email*'
												size='normal' 
												value={streamBusinessEmail}
												id='streamBusinessEmail'
												data-testid='streamBusinessEmail'
												onChange={handleBusinessEmail}
												error={emailError} 
												helperText={emailError ? ENTER_EMAIL : ''}
												/>
										</Grid>
										<Grid item xs={6}>
											<TextField 
												label='Username*'
												id='streamUsername'
												data-testid='streamUsername'
												name='username'
												variant='outlined'
												fullWidth
												value={streamUsername}
												onChange={handleUsername}
												error={userNameError}
												helperText={userNameError ? ENTER_USERNAME : ''}
											/>
										</Grid>
									</Grid>
									
								</FormControl>
								<MerchantAccountDetailsSubCard SUBHEADER1={Stream.SUBHEADER1} HEADER_TEXT1={Stream.HEADER_TEXT1} SUBHEADER2={Stream.SUBHEADER2} HEADER_TEXT2={Stream.HEADER_TEXT2}/>

							</div>
							{errormsg && <div className='error-msg'>{errormsg}</div> }
						</div>
						<div className='merchantAccount-section3'>
							<button 
								onClick={backToStep1}
								className='backButton'
							> 
								{BACK_BUTTON}
							</button>
							<button
								className='continue-button--primaryButton'
								aria-label='Create Account'
								disabled={!streamFormValid}
								variant='outlined'
								onClick={createAccountStream}
								id='createAccountStream'
								data-testid='createAccountStream'
							>
								{CREATE_ACCOUNT}
							</button>
						</div>

					</Paper>
				}

				<div className='margin24'>
					<MerchantAccountDetailsCard selectedAggregator={aggregatorProp} />
				</div>

			</div>
			}
		</>)
}

 export default MerchantAccount;
